import axios from '../lib/dm_axios';
import path from '../config/path';
const apiRootPath = path.apiRootPath;

var Controller = {};

Controller.getListings = async (query, filter, sort) => {
  try {
    const result = await axios.post(apiRootPath + 'marketplace/search', {
      query,
      filter,
      sort,
    });
    return result;
  } catch (error) {
    console.log(error);
  }
};

Controller.createOrder = async (listing) => {
  try {
    const result = await axios.post(apiRootPath + 'marketplace/orders', {
      listingId: listing._id,
    });
    return result;
  } catch (error) {
    console.log(error);
  }
};

Controller.createListing = async (listingData) => {
  try {
    const result = await axios.post(
      apiRootPath + 'marketplace/listings',
      listingData
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

Controller.cancelListing = async (listing) => {
  try {
    const result = await axios.delete(
      apiRootPath + `marketplace/listings/${listing._id}`
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export default Controller;
